export const tableWrapperStyles = {
  gap: 1.5,
  paddingBottom: '16px',
};

export const tableContainerStyles = {
  position: 'relative',
  height: 'calc(100vh - 240px)',
  maxHeight: '436px',
  minHeight: '120px',
  maxWidth: '752px',
  border: '1px solid',
  borderColor: ({ palette }) => `${palette.border.default} !important`,
  borderRadius: '8px',
};

export const tableHeadStyles = {
  position: 'sticky',
  top: 0,
  zIndex: 2,
  backgroundColor: ({ palette }) => palette.background.default,
  borderBottom: 'none',

  '&::after': {
    content: '""',
    position: 'absolute',
    left: 0,
    right: 0,
    bottom: 0,
    height: '1px',
    backgroundColor: ({ palette }) => palette.border.default,
  },

  '& .table-cell': {
    padding: '8px 15px',
    color: ({ palette }) => palette.text.primary,
  },
};

export const tableBodyStyles = {
  overflowY: 'auto',
  scrollBehavior: 'smooth',
  position: 'relative',

  '& .table-cell': {
    padding: '8px 15px',
    color: ({ palette }) => palette.text.secondary,
  },
};

export const footerStyles = {
  flexDirection: 'row',
  justifyContent: 'space-between',
  padding: '12px',
  backgroundColor: ({ palette }) => palette.background.secondary,
  borderRadius: '8px',
};
